import { render, staticRenderFns } from "./wizard.vue?vue&type=template&id=bb8a19c8&scoped=true"
import script from "./wizard.vue?vue&type=script&lang=js"
export * from "./wizard.vue?vue&type=script&lang=js"
import style0 from "./wizard.vue?vue&type=style&index=0&id=bb8a19c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8a19c8",
  null
  
)

export default component.exports